var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgHorloge = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 84.32 85.41",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.16,67.64l-21.59-12.47v-24.93l21.59-12.47,21.59,12.47v24.93l-21.59,12.47ZM23.89,53.25l18.27,10.55,18.27-10.55v-21.1l-18.27-10.55-18.27,10.55v21.1Z",
    fill: "#252544",
    strokeWidth: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 39.14,
    y: 34.01,
    width: 3.32,
    height: 11.32,
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.14,
    y: 43.52,
    width: 12.34,
    height: 3.32,
    fill: "#252544",
    strokeWidth: 0
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHorloge);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Horloge.d8683f6ed1c71ce5fc66b1e07a0f7e9b.svg";